<template>
  <a-layout-content>
    <a-spin :spinning="loading.page">
      <a-row :gutter="16">
        <a-col :xs="24" :lg="24">
          <a-card>
            <a-row slot="title" type="flex" justify="space-between">
              <div><span class="d-block m-text-title">Manifest Rekap Realisasi Lembur</span></div>
              <div>
                <a-button type="primary" @click="downloadExcel">Download</a-button>
              </div>
            </a-row>

            <ul class="list-wrapper bordered">
              <li>
                <span class="list-title">Nomor Rekap</span>
                <span class="list-desc" >{{ source.header[0] ? source.header[0].no_rekap : "" }}</span>
              </li>
              <li>
                <span class="list-title">Tanggal</span>
                <span class="list-desc" >{{ source.header[0] ? moment(source.header[0].create_dt).format(getDefaultDateFormat) : "" }}</span>
              </li>
              <li>
                <span class="list-title">Catatan</span>
                <span class="list-desc" >{{ source.header[0] ? source.header[0].catatan : "" }}</span>
              </li>
            </ul>
          </a-card>
          <a-collapse activeKey="1" forceRender class="margin-top">
            <a-collapse-panel key="1">
              <div class="d-flex justify-between align-middle" slot="header">
                <span class="m-text-title margin-remove">Detil</span>
              </div>
              <a-input-search placeholder="Pencarian" v-model="search" 
                class="textsearch"></a-input-search>
              <a-table
                :key="'detil'"
                :rowKey="(record, index) => { return index; }"
                :columns="columns.detil"
                :dataSource="sourceDtlReturnSearch"
                :pagination="false"
                :scroll="{ y: 500 }"
                size="small"
                bordered
              >
                <span slot="no" slot-scope="text, item, index"> {{ index+1 }}</span>
                <span slot="aksi" slot-scope="item">
                  <a-button type="primary" icon="eye" @click="showManifest(item.realisasi_spl_id)"></a-button>
                </span>
              </a-table>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
      
    </a-spin>
  </a-layout-content>
</template>
<script>

import { mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";

export default ({
  name: "ManifestRealisasiLembur",
  props: ["id"],
  data() {
    return {
      loading: {
        page: false,
      },
      columns: {
        detil: [
          {
          title: "#",
          scopedSlots: { customRender: "no" },
          align: "right",
          width: 15
        },
        {
          title: "No. Realisasi",
          dataIndex: "no_realisasi_spl",
          align: "center",
          width: 75
          },
        {
          title: "Pelaksana",
          dataIndex: "pelaksana",
          align: "center",
          width: 50
          },
        {
            title: "Uraian Tugas",
            dataIndex: "uraian",
            align: "left",
            width: 100
          },
        {
            title: "Aksi",
            align: "center",
            scopedSlots: { customRender: "aksi" },
            width: 20
          },
        ]
      },
      source: {
        header: [],
        detil: [],
        path_file: ""
      },
      search: undefined,
    }
  },
  mounted() {
    this.reload()
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat", "getStandartFormatDate"]),
    sourceDtlReturnSearch() {
      let result = this.source.detil
      if (this.search) {
        result = _.filter(this.source.detil, (e) =>
          e.no_realisasi_spl && e.no_realisasi_spl.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
          e.pelaksana && e.pelaksana.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
          e.uraian && e.uraian.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        )
      }
      return result
    }
  },
  methods: {
    moment,
    reload() {
      this.loading.page = true
      this.asyncAxiosGet("Rekap_realisasi_lembur", this.getAuth, {
        id_rekap: this.id,
      })
        .then((res) => {
          this.source = res
          this.loading.page = false
        })
        .catch((err) => {
          console.log(err)
          this.loading.page = false
        });
    },
    showManifest(id) {
      const route = this.$router.resolve({
        name: "manifestRealisasiSplHrd",
        params: { id: id },
      });
      window.open(route.href, "_blank");
    },
    downloadExcel() {
      window.open(this.$serviceUrl + this.source.path_file, "_blank");
    }
  }
})
</script>
